import { render, staticRenderFns } from "./CrudJudgesList.vue?vue&type=template&id=5948e33a&"
import script from "./CrudJudgesList.vue?vue&type=script&lang=js&"
export * from "./CrudJudgesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports